import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { AssignmentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface AssignmentScoresResponse {
  assignment_scores: AssignmentScoreDataItem[]
}

export interface AssignmentScoreDataItem {
  assignment_uuid: string
  average_score: number
  students: { student_id: number; average_score: number; total_attempts: number }[]
}

export type AssignmentScoresData = AssignmentScoreDataItem[]

export async function assignmentScores(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductWl | LegacyProductFp,
  statsScope: AssignmentsScope,
  period: NormalizedInterval,
): Promise<Nullable<AssignmentScoresData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('assignment_scores', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<AssignmentScoresResponse>(url, query)
  if (!data) return null

  const { assignment_scores } = data

  if (assignment_scores.length === 0) {
    return null
  }

  return assignment_scores
}
